import { deleteRequest, get, patch, post } from "../utils/api";

export const shippingParterCreate = (data) => {
  return post("/admin/settings/shipping-partner", data);
};

export const shippingParterEdit = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/shipping-partner/${id}`, data);
};

export const shippingParterDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/shipping-partner/${id}`);
};

export const shippingParterList = (data) => {
    return get(`/admin/settings/shipping-partner?search=${data?.search||""}&page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const settingCouponCreate = (data) => {
  return post("/admin/settings/coupon", data);
};

export const settingCouponEdit = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/coupon/${id}`, data);
};

export const settingCouponDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/coupon/${id}`);
};

export const settingCouponList = (data) => {
    return get(`/admin/settings/coupon?search=${data?.search||""}&page=${data.page || 1}&limit=${data.limit || 10}`);
};
export const settingDeclarationCreate = (data) => {
  return post("/admin/settings/declaration", data);
};

export const settingDeclarationEdit = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/declaration/${id}`, data);
};

export const settingDeclarationDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/declaration/${id}`);
};

export const settingDeclarationList = (data) => {
    return get(`/admin/settings/declaration?search=${data?.search||""}&page=${data.page || 1}&limit=${data.limit || 10}`);
};
export const settingNotificationCreate = (data) => {
  return post("/admin/settings/notification-template", data);
};

export const settingNotificationEdit = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/notification-template/${id}`, data);
};

export const settingNotificationDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/notification-template/${id}`);
};

export const settingNotificationList = (data) => {
    return get(`/admin/settings/notification-template?search=${data?.search||""}&page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const lockerItemsList = (data) => {
    return get(`/admin/settings/locker-terms?page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const singlelockerItemsList = (data) => {
    return get(`/admin/settings/locker-terms?page=${data.page || 1}&limit=${data.limit || 10}`);
};
export const lockerItemsCreate = (data) => {
  return post("/admin/settings/locker-terms", data);
};

export const lockerItemsUpdate = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/locker-terms/${id}`, data);
};

export const lockerItemsDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/locker-terms/${id}`);
};

export const shopperPricingList = (data) => {
    return get(`/admin/settings/shopper-pricing?page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const singleShopperPricingList = (data) => {
    return get(`/admin/settings/shopper-pricing?page=${data.page || 1}&limit=${data.limit || 10}`);
};

export const ShopperPricingCreate = (data) => {
  return post("/admin/settings/shopper-pricing", data);
};

export const ShopperPricingUpdate = (data) => {
  const id = data.id
  delete data.id
  return patch(`/admin/settings/shopper-pricing/${id}`, data);
};

export const ShopperPricingDelete = (data) => {
  const id = data.id
  return deleteRequest(`/admin/settings/shopper-pricing/${id}`);
};

export const getInvoiceSettings = () => get("/admin/settings/invoice");

export const updateInvoiceSettings = (data) => patch("/admin/settings/invoice", data);

export const settingApi = {
  shippingParterCreate,
  shippingParterList,
  shippingParterEdit,
  shippingParterDelete,
  settingCouponCreate,
  settingCouponEdit,
  settingCouponDelete,
  settingCouponList,
  settingDeclarationCreate,
  settingDeclarationEdit,
  settingDeclarationList,
  settingDeclarationDelete,
  settingNotificationCreate,
  settingNotificationDelete,
  settingNotificationEdit,
  settingNotificationList,
  singlelockerItemsList,
  lockerItemsCreate,
  lockerItemsList,
  lockerItemsUpdate,
  lockerItemsDelete,
  ShopperPricingCreate,
  ShopperPricingUpdate,
  ShopperPricingDelete,
  shopperPricingList,
  singleShopperPricingList,
  getInvoiceSettings,
  updateInvoiceSettings,
};
